import { render, staticRenderFns } from "./GratitudeAndSuggestionTicket.vue?vue&type=template&id=504f5c14&scoped=true"
import script from "./GratitudeAndSuggestionTicket.vue?vue&type=script&lang=js"
export * from "./GratitudeAndSuggestionTicket.vue?vue&type=script&lang=js"
import style0 from "./GratitudeAndSuggestionTicket.vue?vue&type=style&index=0&id=504f5c14&prod&lang=scss&scoped=true"
import style1 from "./GratitudeAndSuggestionTicket.vue?vue&type=style&index=1&id=504f5c14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504f5c14",
  null
  
)

export default component.exports